module.exports = __webpack_public_path__ + "static/media/downloadIcon.d77acfcd.svg";